<template>
  <div class="img-wrapper">
    <UDropdown
        v-model="open"
        :items="dropdownContent"
        :popper="{ placement: 'bottom-start' }">
      <template #default>
        <div class="userInfo">
          <div
              v-if="!userIcon"
              class="icon">{{ user?.name[0] }}
          </div>
          <img
              v-else
              class="userIcon"
              :src="userIcon"
              alt="userIcon" />
        </div>
      </template>
      <template #menu="{ item }">
        <NuxtLink
            no-prefetch
            class="dropdown-item block w-full text-left"
            @click="gotoProfilePage(item.page)"
        >
          {{ $t(item.label) }}
        </NuxtLink>
      </template>
      <template #base>
        <div
            class="userInfo"
            @click="navigateTo('/profile?page=profile-settings')">
          <div
              v-if="!userIcon"
              class="icon">{{ user?.name[0] }}
          </div>
          <img
              v-else
              class="userIcon"
              :src="userIcon"
              alt="userIcon" />
          <p class="userName">{{ user?.name }}</p>
        </div>
      </template>
      <template #logout>
        <div
            class="logout w-full text-left"
            @click="logout">
          {{ $t('profile.logout') }}
        </div>
      </template>
    </UDropdown>
  </div>
</template>

<script
    setup
    lang="ts">
import {useAuthStore} from '~/store/auth';
import {useUserStore} from '~/store/user';
import {ref} from 'vue';
import {useCustomerFavoriteStore} from '~/store/customer-favorite';
import {useRouter} from '#vue-router';

const userStore = useUserStore();
const {user, userIcon} = storeToRefs(userStore);
const authStore = useAuthStore();
const open = ref<boolean>(false);
const favsStore = useCustomerFavoriteStore();
const router = useRouter();

onMounted(async() => {
  userStore.initUser();
  userStore.initUserIcon();
});

const dropdownContent = [
  [{slot: 'base'}],
  [
    {label: 'profile.ads', page: 'profile-ads', slot: 'menu'},
    {label: 'profile.settings', page: 'profile-settings', slot: 'menu'},
    {label: 'profile.support', page: 'profile-support', slot: 'menu'},
  ],
  [{slot: 'logout'}],
];

const gotoProfilePage = (page: string) => {
  router.push({path: '/profile', query: {page}});
  open.value = false;
};

const logout = async() => {
  await authStore.logout();
  favsStore.clearFavorites();
  router.push({path: '/'});
};
</script>

<style
    scoped
    lang="scss">
.img-wrapper {
  position: relative;
  border-radius: 50%;
}

.img {
  border-radius: 50%;
  width: 36px;
  margin-top: 8px;
  object-position: center;
  object-fit: cover;
  cursor: pointer;
}

.dropdown-item {
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;
}

.icon {
  width: 36px;
  height: 36px;
  background-color: #c03060;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #fff;
}

.userInfo {
  display: flex;
  gap: 8px;
  align-items: center;
}

.userName {
  font-size: 16px;
}

.dropdownIcon {
  cursor: pointer;
}

.divider {
  height: 1px;
  width: 100%;
  background-color: #e3e6e8;
}

.logout {
  color: #ff1818;
  cursor: pointer;
  font-size: 16px;
}

.userIcon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>
